import React from 'react';
import './Club.css'

const Club = (props) => {
    const club = props.club;
    console.log(props.club)

    let total = 0;
    for (let i = 0; i < club.length; i++) {
        const player = club[i];
        total = total + player.salary;
        
    }

    return (
        <div>
            <h4 className="title">Bangladesh Female Cricket 2021</h4>
            <h5>Total Team Member:{club.length}</h5>
            <h5>Total Salary:{total}</h5>
            <hr/><hr/>
            <div>
                {
                    club.map(members =>
                        <div className="club-player">
                            <h4>Name: {members.name}</h4>
                            <h5>Salary:{members.salary}</h5>
                        </div>
                    )                
                }
            </div>
        </div>
    );
};

export default Club;